import { PreferredSoccerMainBetType } from '@nf/types/account';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useAccountInfo } from '@/hooks/query/account';

const defaultPreferredMainBetType = {
	1: PreferredSoccerMainBetType.OneXTwo,
	997: PreferredSoccerMainBetType.OneXTwo,
	9995: PreferredSoccerMainBetType.OneXTwo,
};

export const usePreferredMainBetType = () => {
	const { SiteConfigsData } = useGetSiteConfigs();
	const { user } = useAccountInfo();

	return SiteConfigsData?.Enable1x2Customization
		? user?.UserSetting.SportsBetTypesSetting ?? defaultPreferredMainBetType 
		: defaultPreferredMainBetType;
};